import React from 'react';
import { Brain, Download, Star, Globe, HardDrive } from 'lucide-react';

const models = [
  { id: 'qwen', name: 'Qwen2.5:7b', type: 'Local', provider: 'Ollama', status: 'ready', size: '4.1 GB', stars: 5 },
  { id: 'llama', name: 'Llama 3.1:8b', type: 'Local', provider: 'Ollama', status: 'ready', size: '4.7 GB', stars: 4 },
  { id: 'bitnet', name: 'BitNet b1.58', type: 'Local', provider: 'Custom', status: 'ready', size: '0.8 GB', stars: 3 },
  { id: 'gemini', name: 'Gemini 2.0 Flash', type: 'External', provider: 'Google', status: 'ready', size: '-', stars: 5 },
  { id: 'claude', name: 'Claude 3.5 Sonnet', type: 'External', provider: 'Anthropic', status: 'ready', size: '-', stars: 5 },
  { id: 'mixtral', name: 'Mistral 8x7B', type: 'Local', provider: 'Ollama', status: 'downloading', size: '26 GB', stars: 4 },
];

function ModelSection() {
  return (
    <div className="p-8 space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-bold text-white">AI Models</h2>
          <p className="text-slate-400 mt-1">Manage local and external model providers</p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2.5 bg-purple-600 hover:bg-purple-500 text-white rounded-xl text-sm font-medium transition-all duration-200 purple-glow">
          <Download className="w-4 h-4" />
          Download Model
        </button>
      </div>

      <div className="glass-panel divide-y divide-slate-800/50">
        <div className="p-6">
          <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider">Available Models</h3>
        </div>
        {models.map((model) => (
          <div key={model.id} className="p-5 hover:bg-slate-800/30 transition-colors">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-lg bg-purple-600/20 flex items-center justify-center">
                  <Brain className="w-5 h-5 text-purple-400" />
                </div>
                <div>
                  <p className="text-white font-semibold flex items-center gap-2">
                    {model.name}
                    {Array.from({ length: model.stars }).map((_, i) => (
                      <Star key={i} className="w-3 h-3 text-amber-400 fill-amber-400" />
                    ))}
                  </p>
                  <p className="text-xs text-slate-500">{model.provider}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                  model.type === 'Local'
                    ? 'bg-emerald-600/20 text-emerald-400'
                    : 'bg-blue-600/20 text-blue-400'
                }`}>
                  {model.type}
                </span>
                {model.size && model.size !== '-' && (
                  <span className="text-xs text-slate-500 flex items-center gap-1">
                    <HardDrive className="w-3 h-3" /> {model.size}
                  </span>
                )}
                <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                  model.status === 'ready'
                    ? 'bg-emerald-600/20 text-emerald-400'
                    : 'bg-amber-600/20 text-amber-400'
                }`}>
                  {model.status === 'ready' ? 'READY' : 'DOWNLOADING...'}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ModelSection;
